import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy /blog/$slug routes redirect to canonical /en/blog/$slug (SEO-008).
// English is the primary SEO target — most inbound links reference English slugs.
// Falls back to the slug as-is if not found in EN posts.
export const Route = createFileRoute("/blog/$slug")({
  // Async + dynamic import so this redirect-only route does not pull the post corpus
  // into the shared chunk. It runs once, on a legacy URL, so the extra fetch is free.
  beforeLoad: async ({ params }) => {
    const { getPost } = await import("@/lib/blog-posts");
    const post = getPost("en", params.slug);
    throw redirect({
      to: "/$lang/blog/$slug",
      params: { lang: "en", slug: post ? post.slug : params.slug },
      replace: true,
      // 301, not the default 307: this move is permanent, and a temporary redirect
      // leaves the old URL sitting in Search Console as "Page with redirect" for good.
      statusCode: 301,
    });
  },
  component: () => null,
});
